import React, { useContext } from 'react';
import { ReservationContext } from 'context/ReservationProvider';
import Messaging from 'components/Messaging/Messaging';
import Loader from 'components/Loader/Loader';

const Messages = ({
  user,
  reservation,
  marina,
  id,
  isAllowed,
  isReservation,
  isMissingRequirements,
  location
}) => {
  const { messagesAndStatuses, unread, read, sendMessage } =
    useContext(ReservationContext);

  if (!id) {
    return <Loader />;
  }

  return (
    <Messaging
      className='reservation-chat'
      isAllowed={isAllowed}
      isReservation={isReservation}
      messages={messagesAndStatuses}
      unread={unread}
      read={read}
      sendMessage={sendMessage}
      marina={marina}
      user={user}
      reservation={reservation}
      location={location}
      isMissingRequirements={isMissingRequirements}
    />
  );
};

export default Messages;
